<template>
	<div class="card" v-if="cuenta">
		<div class="card-header">Editor de cuentas</div>
		<div class="card-body">
			<h4>Datos generales</h4>
			<div class="row">
				<div class="col">
					<div class="form-group">
						<label for="">Cuenta</label>
						<input type="text" class="form-control form-control-sm" placeholder="nombre" v-model="cuenta.cuenta">
					</div>
				</div>
				<div class="col">
					<div class="form-group">
						<label for="">Dominio</label>
						<select name="" id="" class="form-control form-control-sm" v-model="cuenta.dominio_id">
							<option :value="dominio.id" v-for="dominio in listadoDominios" :key="dominio.id">{{dominio.dominio}}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col">
					<div class="form-group">
						<label for="">Cuota</label>
						<div class="input-group input-group-sm">
							<input type="number" class="form-control form-control-sm" v-model="cuenta.quota_gb">
							<div class="input-group-append">
								<span class="input-group-text">Gb</span>
							</div>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="form-group">
						<label for="">Usuario asignado</label>
						<input-query v-if="!cuenta.usuario" url="gestion-cuentas-email/php/queryUsuarios.php" input-class="form-control form-control-sm" :realtime="true" @selected="setUsuario($event)" placeholder="Asigna un usuario"></input-query>
						<div class="input-group input-group-sm" v-if="cuenta.usuario">
							<input class="form-control" disabled :value="cuenta.usuario.nombre + ' ' + cuenta.usuario.apellidos">
							<div class="input-group-append">
								<button class="btn btn-danger" @click="quitaUsuario">
									<span class="fa fa-trash"></span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card-body bg-light" v-if="cuenta.id">
			<h4>Tokens de acceso</h4>
		</div>
		<div class="table-responsive" v-if="cuenta.id">
			<table class="table table-condensed table-striped m-0">
				<thead class="bg-dark text-white">
					<tr>
						<th style="vertical-align:middle;">Nombre</th>
						<th style="vertical-align:middle;">Fecha de creación</th>
						<th style="vertical-align:middle;">Último acceso</th>
						<th class="text-right">
							<button class="btn btn-sm btn-warning" @click="creandoToken = true">
								<span class="fa fa-plus mr-2"></span>
								Nuevo
							</button>
						</th>
					</tr>
				</thead>
				<thead class="bg-light" v-if="creandoToken">
					<tr>
						<th colspan="4">
							<div class="input-group input-group-sm">
								<input type="text" class="form-control form-control-sm" v-model="token.nombre" placeholder="Escribe un nombre">
								<div class="input-group-append">
									<button class="btn btn-sm btn-primary" @click="nuevoToken">
										<span class="fa fa-plus mr-2"></span>
										Crear
									</button>
									<button class="btn btn-sm btn-danger" @click="cancelarCrearToken">
										<span class="fa fa-trash mr-2"></span>
										Cancelar
									</button>	
								</div>
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="token in cuenta.tokens" :key="token.id">
						<td>{{token.nombre}}</td>
						<td>{{new Date(token.fecha_creacion * 1000).toLocaleDateString()}}</td>
						<td>
							<span v-if="token.fecha_acceso">
								{{new Date(token.fecha_acceso * 1000).toLocaleDateString()}}
							</span>
							<span v-if="!token.fecha_acceso">
								Nunca
							</span>
						</td>
						<td class="text-right">
							<button class="btn btn-sm btn-danger" @click="delToken(token.id)">
								<span class="fa fa-trash"></span>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="card-footer" v-if="formValido">
			<button class="btn btn-sm btn-primary" @click="guardar">
				<span class="fa fa-save mr-2"></span>
				Guardar
			</button>
			<button class="btn btn-sm btn-danger" @click="eliminar">
				<span class="fa fa-trash mr-2"></span>
				Eliminar cuenta
			</button>
		</div>
	</div>
</template>

<script>
import API from './api'
export default {
	props: ['idCuenta'],
	data () {
		return {
			cuenta: null,
			listadoDominios: [],
			token: {
				nombre: ''
			},
			creandoToken: false
		}
	},

	watch: {
		idCuenta: function (nuevo, anterior) {
			if (nuevo === 'nueva') {
				this.cuenta = {
					id: null,
					cuenta: '',
					dominio_id: null,
					quota_gb: 5,
					usuario_id: null,
					usuario: null
				}
			} else {
				this.getCuenta()
			}
		}
	},

	computed: {
		formValido () {
			return (this.cuenta.cuenta && this.cuenta.dominio_id && this.cuenta.quota_gb)
		}
	},

	created () {
		this.getDominios()
		if (this.idCuenta !== 'nueva') {
			// Obtenemos la cuenta
			this.getCuenta()
		} else {
			this.cuenta = {
				id: null,
				cuenta: '',
				dominio_id: null,
				quota_gb: 5,
				usuario_id: null,
				usuario: null
			}
		}
	},

	methods: {
		getCuenta () {
			if (!this.idCuenta) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'No existe un id de cuenta válido'
				})
				return
			}
			API.getCuenta(this.idCuenta)
				.then(res => {
					this.cuenta = res.data.cuenta
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		getDominios () {
			API.getDominios()
				.then(res => {
					this.listadoDominios = res.data.dominios
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		setUsuario (ev) {
			this.cuenta.usuario_id = ev.datos.ID
			this.cuenta.usuario = ev.datos
		},
		quitaUsuario () {
			this.cuenta.usuario_id = null
			this.cuenta.usuario = null
		},
		guardar () {
			API.setCuenta(this.cuenta)
				.then(res => {
					this.cuenta = res.data.cuenta
					this.$emit('update')
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		nuevoToken () {
			if (!this.token.nombre) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes escribir un nombre'
				})
				return
			}

			API.setToken(this.cuenta.id, this.token.nombre)
				.then(res => {
					this.getCuenta()

					this.$store.commit('alertas/alert', {
						titulo: 'Correcto',
						mensaje: `Se ha generado un nuevo token de acceso para esta cuenta. Éste es:
						<b>${res.data.token}</b>
						Es recomendable que configures tu cuenta ahora con este token, pues ya no lo podrás recuperar.`
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		cancelarCrearToken () {
			this.token.nombre = ''
			this.creandoToken = false
		},
		delToken (idToken) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar token',
				mensaje: '¿Quieres eliminar este token?',
				callback: (acepta) => {
					if (acepta) {
						API.delToken(idToken)
							.then(res => {
								this.getCuenta()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Error',
				mensaje: '¿Quieres eliminar esta cuenta de correo?',
				callback: (acepta) => {
					if (acepta) {
						API.delCuenta(this.cuenta.id)
							.then(() => {
								this.$emit('update')
								this.cuenta = null
								this.idCuenta = null
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}

}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-cuentas-email/vue/editor-cuentas.vue